import axios from 'axios';
import api from '../../../utils/api';
import authService from '../../auth/services/authService';

const API_URL = import.meta.env.VITE_API_URL 
  ? `${import.meta.env.VITE_API_URL}/api`
  : 'http://localhost:3001/api';

/**
 * Category Service
 * Handles API calls related to transaction categories
 */
const categoryService = {
  /**
   * Get all categories (system + user)
   * @returns {Promise} Promise with categories data
   */
  getAllCategories: async () => {
    try {
      const response = await api.get(`/api/categories`);
      
      return {
        success: true,
        data: response.data.data || response.data,
        count: response.data.count
      };
    } catch (error) {
      console.error('Error fetching categories:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch categories',
        error
      };
    }
  },
  
  /**
   * Get a single category by ID
   * @param {string} id Category ID
   * @returns {Promise} Promise with category data
   */
  getCategoryById: async (id) => {
    try {
      const response = await api.get(`/api/categories/${id}`);
      
      return {
        success: true,
        data: response.data.data || response.data
      };
    } catch (error) {
      console.error(`Error fetching category ${id}:`, error);
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch category',
        error
      };
    }
  },
  
  /**
   * Create a new category
   * @param {Object} categoryData Category data (name, color, icon, keywords)
   * @returns {Promise} Promise with created category data
   */
  createCategory: async (categoryData) => {
    try {
      const response = await api.post(`/api/categories`, categoryData);
      
      return {
        success: true,
        data: response.data.data || response.data
      };
    } catch (error) {
      console.error('Error creating category:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to create category',
        error
      };
    }
  },
  
  /**
   * Update a category
   * @param {string} id Category ID
   * @param {Object} categoryData Updated category data
   * @returns {Promise} Promise with updated category data
   */
  updateCategory: async (id, categoryData) => {
    try {
      const response = await api.put(`/api/categories/${id}`, categoryData);
      
      return {
        success: true,
        data: response.data.data || response.data
      };
    } catch (error) {
      console.error(`Error updating category ${id}:`, error);
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to update category',
        error
      };
    }
  },
  
  /**
   * Delete a category
   * @param {string} id Category ID
   * @returns {Promise} Promise with success status
   */
  deleteCategory: async (id) => {
    try {
      await api.delete(`/api/categories/${id}`);
      
      return {
        success: true
      };
    } catch (error) {
      console.error(`Error deleting category ${id}:`, error);
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to delete category',
        error
      };
    }
  }
};

export default categoryService; 